// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"659":"7661fac7","977":"de84aab0"}[chunkId] + ".css";
};